<template>
  <base-modal
    trigger-class-modal="modal-sm"
    :show-modal="showModal"
    @close="onCancel"
    v-click-outside="onCancel"
  >
    <template #header>
      <span class="font-semibold text-h2">
        {{ $t("App.Regions.selectionModalTitle") }}
      </span>
    </template>

    <div class="flex flex-col h-full">
      <div class="flex mt-4" v-if="regionName">
        {{ $t("App.Regions.currentRegion", { regionName: this.regionName }) }}
      </div>
      <div class="mt-4" v-if="regionName">
        {{ $t("App.Regions.selectionModalText") }}
      </div>
      <div class="flex h-full items-center mt-2">
        <div class="flex flex-col w-full items-center">
          <!-- The div below aligns the base radio buttons on the left once centered -->
          <div>
            <base-radio
              v-for="(region, key) in regionData"
              :key="key"
              :class="[
                { 'pt-6': key > 0 },
                { 'pb-6': key === regionData.length - 1 },
              ]"
              name="region"
              :value="region.Id"
              @input="onRegionSelect"
              :checked="false"
            >
              <span class="text-h3">{{ $t(region.NameTk) }}</span>
            </base-radio>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex flex-col w-full items-center p-4">
        <base-button
          class="btn-primary"
          @click="onConfirm"
          :disabled="!selectedRegionId"
        >
          {{ $t("Common.Button.confirm") }}
        </base-button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from "@/components/ui/BaseModal.vue";
import BaseRadio from "@/components/ui/BaseRadio.vue";
import vClickOutside from "v-click-outside";

export default {
  components: {
    BaseRadio,
    BaseModal,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    // Format:
    // [{ Id: "eu", NameTk: "Europe", BaseURL: "dev.eu.mm-companion.com" }, ...]
    regionData: {
      type: Array,
      default: () => [],
    },
    currentRegion: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedRegionId: "",
    };
  },
  computed: {
    regionName() {
      return this.currentRegion ? this.$t(this.currentRegion.NameTk) : "";
    },
  },
  methods: {
    onCancel() {
      if (event.type === "touchstart") {
        return;
      }
      this.$emit("cancel");
    },
    onRegionSelect(value) {
      this.selectedRegionId = value;
    },
    onConfirm() {
      if (this.selectedRegionId) {
        const region = this.regionData.find(
          (e) => e.Id === this.selectedRegionId
        );
        if (region && region.BaseURL) {
          window.location.href = `${region.BaseURL}`;
        }
      }
    },
  },
  watch: {
    showModal() {
      if (this.showModal) {
        // clear selection
        this.selectedRegionId = "";
      }
    },
  },
};
</script>
